MOVE.CustomSmartbanner = (function(MOVE) {

  var init = function() {
    closeCustomBanner();
    keepBannerClosed();
    toggleCustomBannerOnMapView();
  };

  var closeCustomBanner = function () {
    $('#store-smartbanner').on('click', '.sb-close', function() {
      setDismissalExpiry();
      hideCustomBanner();
    });
  };

  // If user has dismissed the banner and is still active in session, keep cookie active.
  var keepBannerClosed = function() {
    if ($.cookie('bannerDismissed')) {
      setDismissalExpiry();
    }
  };

  var setDismissalExpiry = function() {
    var date = MOVE.Helper.setCookieExpiry(30);
    $.cookie('bannerDismissed', true, { path: '/', expires: date});
  };

  var toggleCustomBannerOnMapView = function () {
    $('.srp-view-list-toggle').on('click', function () {
      showCustomBanner();
    });
    $('.srp-view-map-toggle').on('click', function () {
      hideCustomBanner();
    });
  };

  var hideCustomBanner = function () {
    $('#store-smartbanner').addClass('hide');
  };

  var showCustomBanner = function () {
    if (!$.cookie('bannerDismissed')) {
      $('#store-smartbanner').removeClass('hide');
    }
  };

  MOVE.CustomSmartbanner = {
    init: init
  };

  return MOVE.CustomSmartbanner;

}(MOVE || {}));



// WEBPACK FOOTER //
// ./shared_critical/custom_smartbanner.js